import { render, staticRenderFns } from "./RuZhi.vue?vue&type=template&id=2e5758e5&scoped=true&"
import script from "./RuZhi.vue?vue&type=script&lang=js&"
export * from "./RuZhi.vue?vue&type=script&lang=js&"
import style0 from "./RuZhi.vue?vue&type=style&index=0&id=2e5758e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5758e5",
  null
  
)

export default component.exports